import script from "./Save.vue?vue&type=script&setup=true&lang=ts"
export * from "./Save.vue?vue&type=script&setup=true&lang=ts"

import "./Save.vue?vue&type=style&index=0&id=6a0cf7ac&scoped=true&lang=css"
import "./Save.vue?vue&type=style&index=1&id=6a0cf7ac&lang=css"

import exportComponent from "/home/runner/work/The-Jojo-Tree/The-Jojo-Tree/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a0cf7ac"]])

export default __exports__